<template>
  <div class="c-app role-theme-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar />
    
    <TheHeader />

    <div
      class="c-wrapper"
      :class="{
        'sidebar-open': $store.state.sidebarShow && !$store.state.sidebarMinimize,
        'sidebar-minimized': $store.state.sidebarMinimize
      }"
    >
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <router-view></router-view>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <RoleBottomNav role="admin" />

    <!-- Global Floating Report Action Button -->
    <FloatingReportFab />

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "../TheFooter";
import RoleBottomNav from "@/components/common/RoleBottomNav.vue";
import FloatingReportFab from "@/components/common/FloatingReportFab.vue";
import { mapActions } from "vuex";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    RoleBottomNav,
    FloatingReportFab,
  },
  mounted() {
    document.body.classList.add('role-unified-theme');
    this.loadUserProfile();
  },
  beforeDestroy() {
    document.body.classList.remove('role-unified-theme');
  },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() {
      try {
        await this.getProfile();
      } catch (err) {
        console.error("Load profile error:", err);
      }
    },
  },
};
</script>

<style scoped>
/* Base Wrapper Style */
.c-wrapper {
  transition: margin-left 0.3s ease;
  margin-left: 0; /* ค่าเริ่มต้น (Mobile) เป็น 0 */
  min-height: 100vh;
}

/* ดันเนื้อหาลงมาใต้ Header */
.c-body {
  padding-top: 82px;
}

/* =========================================
   🔥 แก้ไขตรงนี้: สั่งให้ดันเนื้อหา เฉพาะในคอมพิวเตอร์ 🔥
   ========================================= */
@media (min-width: 1201px) {
  /* ทำงานเฉพาะหน้าจอที่กว้างกว่า 992px (Desktop/Tablet แนวนอน) */
  .sidebar-open {
    margin-left: 250px; /* ดันเนื้อหาหลบ Sidebar */
  }
  
  .sidebar-minimized {
    margin-left: 70px; /* กรณีพับ Sidebar */
  }
}
</style>
